import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component, useState } from 'react';
import uniqueId from 'lodash.uniqueid';
import { ErrorMessage } from 'formik';
import { Form, Input, Label } from 'react-bootstrap';
import MaskedInput from 'react-text-mask';
import { IoIosCloseCircle } from 'react-icons/io'; // Global Form Methods

import FormMethods from './Methods'; // Input masks

import { masks } from '../util/masks';

var FormControlledInput = /*#__PURE__*/function (_Component) {
  _inherits(FormControlledInput, _Component);

  var _super = _createSuper(FormControlledInput);

  function FormControlledInput(props) {
    var _this;

    _classCallCheck(this, FormControlledInput);

    _this = _super.call(this, props);
    _this.handleFocus = FormMethods.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleBlur = FormMethods.handleBlur.bind(_assertThisInitialized(_this));
    _this.state = {
      name: props.field.name,
      active: typeof props.value !== 'undefined' && props.value !== '' ? true : false
    };
    _this.id = uniqueId();
    return _this;
  }

  _createClass(FormControlledInput, [{
    key: "onChange",
    value: function onChange(e) {
      this.props.form.setFieldValue(e.currentTarget.name, e.currentTarget.value);

      if (typeof this.props.changeHandler !== 'undefined') {
        return this.props.changeHandler(e.currentTarget.value);
      }

      if (typeof this.props.changeFullHandler !== 'undefined') {
        return this.props.changeFullHandler(e);
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$field = _this$props.field,
          name = _this$props$field.name,
          field = _objectWithoutProperties(_this$props$field, ["name"]),
          props = _objectWithoutProperties(_this$props, ["field"]);

      var errors = this.props.form.errors;
      var touched = this.props.form.touched;
      var Tag = this.props.type === 'tel' || this.props.type === 'customDate' ? MaskedInput : Form.Control;

      var mask = function (maskType) {
        switch (maskType) {
          case 'tel':
            return masks.phoneNumber;

          case 'customDate':
            return masks.date;

          default:
            return null;
        }
      }(this.props.type);

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
        controlId: "".concat(this.props.field.name, "-").concat(this.id),
        onBlur: this.handleBlur
      }, /*#__PURE__*/React.createElement(Form.Label, {
        className: "\n            cb-form__label\n            ".concat(this.props.value || this.state.active ? 'is-active' : '', "\n            ").concat(this.props.type === 'date' ? 'is-date' : '', "\n            ").concat(this.props.type === 'datetime-local' ? 'is-date' : '', "\n            ").concat(typeof field.value !== 'undefined' && field.value !== '' ? 'is-filled' : '', "\n          ")
      }, this.props.label || name), /*#__PURE__*/React.createElement(Tag, {
        className: "\n              cb-form__input\n              form-control\n              ".concat(this.props.className, "\n              ").concat(this.props.value || this.state.active ? 'is-active' : '', "\n              ").concat(typeof field.value !== 'undefined' && field.value !== '' ? 'is-filled' : '', "\n              ").concat(errors[this.props.field.name] && touched[this.props.field.name] ? 'is-error' : '', "\n            ") // id={`${this.props.field.name}-${this.id}`}
        ,
        id: this.props.type === 'tel' || this.props.type === 'customDate' ? "".concat(this.props.field.name, "-").concat(this.id) : null,
        name: this.props.field.name,
        type: this.props.type,
        placeholder: this.props.placeholder,
        disabled: this.props.disabled,
        value: this.props.value,
        autoComplete: this.props.autocomplete,
        onChange: function onChange(e) {
          return _this2.onChange(e);
        },
        onBlur: field.onBlur,
        onFocus: this.handleFocus,
        onError: field.handleError,
        mask: mask
      }), /*#__PURE__*/React.createElement(ErrorMessage, {
        name: name
      }, function (msg) {
        return /*#__PURE__*/React.createElement("div", {
          className: "cb-form__error-message"
        }, /*#__PURE__*/React.createElement(IoIosCloseCircle, null), " ", msg);
      })));
    }
  }]);

  return FormControlledInput;
}(Component);

FormControlledInput.defaultProps = {
  type: "text",
  value: "",
  className: "",
  placeholder: ""
};
export default FormControlledInput;